import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/clubVacationVouchers',
        name: 'clubVacationVouchers',
        meta: { sideMenuLabel: "Voucher vacanza" },
        component: () => import("./views/clubVacationVouchers.vue")
    },

];

export default routes;